import BaseService from "./BaseService";

const USUARIOS_API = `${process.env.REACT_APP_ENDPOINT}usuarios/api`;
const FAZENDAS_API = `${process.env.REACT_APP_ENDPOINT}fazendas/api`;

export type BenchmarkLocalUserStatus = "active" | "inactive" | "not_found";

export type BenchmarkUserStatusResponse = {
  hasUserAccess: boolean;
  hasContextualAccess: boolean;
  localUserStatus: BenchmarkLocalUserStatus;
};

export type BenchmarkFarmAccess = {
  name: string;
  has_access: boolean;
};

export type BenchmarkClienteFazendas = {
  nomeCliente: string;
  fazendas: BenchmarkFarmAccess[];
};

export type BenchmarkGrantBody = {
  action: "grant";
  name: string;
  associations: Array<{ customer_name: string; farm_names: string[] }>;
};

export type BenchmarkRevokeBody = {
  action: "revoke";
};

export type FazendaBenchmarkAccessResponse = {
  has_access: boolean;
};

export type FazendaBenchmarkGrantBody = {
  acao: "grant";
  customer_name: string;
  country_alpha2: string;
  city: string;
  region: string;
};

export type FazendaBenchmarkRevokeBody = {
  acao: "revoke";
  customer_name: string;
};

class BenchmarkService extends BaseService {
  async getAcessoBenchmark(
    email: string,
    customerName?: string,
    farmName?: string
  ): Promise<BenchmarkUserStatusResponse> {
    const response = await this.get(
      `${USUARIOS_API}/v2/usuarios/acesso-benchmark/${encodeURIComponent(email)}`,
      { customer_name: customerName, farm_name: farmName }
    );
    return response.data;
  }

  async putAcessoBenchmark(
    email: string,
    body: BenchmarkGrantBody | BenchmarkRevokeBody,
  ): Promise<void> {
    await this.put(
      `${USUARIOS_API}/v2/usuarios/acesso-benchmark/${encodeURIComponent(email)}`,
      body,
    );
  }

  async getClienteFazendasBenchmarkAccess(
    nomeCliente: string,
    farmNames: string[],
  ): Promise<{ farms: BenchmarkFarmAccess[] }> {
    const response = await this.get(
      `${FAZENDAS_API}/v1/fazendas/benchmark/acesso/cliente/${encodeURIComponent(nomeCliente)}`,
      { nomeFazendas: farmNames.join(",") },
    );
    return response.data;
  }

  async generateBenchmarkOtt(): Promise<{ ott: string }> {
    const response = await this.post(`${USUARIOS_API}/v1/usuarios/benchmark-ott`, {});
    return response.data.data;
  }

  async getFazendaBenchmarkAccess(
    nomeFazenda: string,
    nomeDoCliente: string,
  ): Promise<FazendaBenchmarkAccessResponse> {
    const response = await this.get(
      `${FAZENDAS_API}/v1/fazendas/benchmark/acesso/${encodeURIComponent(nomeFazenda)}`,
      { nomeDoCliente },
    );
    return response.data;
  }

  async putFazendaBenchmarkAccess(
    nomeFazenda: string,
    body: FazendaBenchmarkGrantBody | FazendaBenchmarkRevokeBody,
  ): Promise<void> {
    await this.put(
      `${FAZENDAS_API}/v1/fazendas/benchmark/acesso/${encodeURIComponent(nomeFazenda)}`,
      body,
    );
  }
}

const benchmarkService = new BenchmarkService();

export default benchmarkService;
